import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { format, parseISO } from "date-fns";
import { de, zhCN, fr, it, es } from "date-fns/locale";

import Image from "../Global/Image";
import Link from "../Global/Link";

const CardNews = (props) => {
  const { data } = props;

  const country = useSelector((state) => state.global.country);

  let countryFormatCode = null;
  if (country === "de") {
    countryFormatCode = de;
  } else if (country === "es") {
    countryFormatCode = es;
  } else if (country === "fr") {
    countryFormatCode = fr;
  } else if (country === "it") {
    countryFormatCode = it;
  } else if (country === "zh") {
    countryFormatCode = zhCN;
  }

  const item = JSON.parse(data.content);

  if (!item) return null;
  return (
    <div
      className={`d-flex flex-column justify-content-start brand-background-white brand-text-black overflow-hidden h-100 position-relative brand-cursor`}
    >
      {item.image?.filename && (
        <Image
          src={item.image?.filename}
          sm="600x338"
          md="600x338"
          lg="600x338"
          alt={item.image?.alt}
          className="ratio ratio-16x9 mb-2"
        />
      )}

      {item.date && (
        <p className="text-uppercase brand-text-dark-green mb-2 small">
          {format(parseISO(item.date), "MMMM d, yyyy", {
            locale: countryFormatCode,
          })}
        </p>
      )}

      {item.title && <h3 className="brand-font m-0">{item.title}</h3>}

      {data?.full_slug && <Link to={data.full_slug} stretched />}
    </div>
  );
};

export default CardNews;

CardNews.propTypes = {
  data: PropTypes.object,
};

CardNews.defaultProps = {
  data: null,
};
